<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-card flat color="grey lighten-4">
        <v-card-text>
          <v-autocomplete
            v-model="fornecedor_id"
            label="Fornecedor"
            clearable
            filled
            dense
            hide-details
            :items="props.fornecedores"
          >
            <template #item="{ item }">
              <v-list-item-content>
                <v-list-item-title v-html="item.text"></v-list-item-title>
                <v-list-item-subtitle v-html="item.celular"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-btn depressed rounded color="primary" @click="adicionarFornecedor">Adicionar Fornecedor</v-btn>
          <v-btn depressed rounded text @click="$emit('cancelar:fornecedor')">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();

const props = defineProps({
  fornecedores: {
    type: Array,
    default: [],
  },
});

const emits = defineEmits(['adicionar:fornecedor', 'cancelar:fornecedor']);

const fornecedor_id = ref(null);

function adicionarFornecedor() {
  if (fornecedor_id.value) {
    const fornecedor = getFornecedorById(fornecedor_id.value);
    emits('adicionar:fornecedor', fornecedor);
    fornecedor_id.value = null;
  }
}

function getFornecedorById(id) {
  return proxy.$store.state.listas.fornecedores.find(f => f.id == id);
}

</script>

<style lang="scss" scoped>

</style>